import React from 'react';
import PageLayout from '../../PageLayout';
import Login from './Login';

const LoginPage = () => {
  return (
    <PageLayout>
      <Login />
    </PageLayout>
  );
};

export default LoginPage;
